/* Guia de tamanhos — chapelaria.
   Os tamanhos desta loja trazem a amplitude no próprio nome ("Regular · 55–58 cm"),
   por isso o guia lê-a da ficha em vez de usar uma tabela paralela que podia divergir. */
(function(){
  'use strict';
  var raiz=document.querySelector('[data-jw]'); if(!raiz) return;
  var T={}; var cfg=document.querySelector('[data-jw-cfg]');
  if(cfg) Array.prototype.forEach.call(cfg.attributes,function(a){
    if(a.name.indexOf('data-t-')===0) T[a.name.slice(7)]=a.value; });
  function txt(k,d){ return T[k]||d; }

  var ultimoFoco=null;
  function abrir(){ ultimoFoco=document.activeElement; raiz.hidden=false;
    document.documentElement.style.overflow='hidden';
    var f=raiz.querySelector('input'); if(f) f.focus(); }
  function fechar(){ raiz.hidden=true; document.documentElement.style.overflow='';
    if(ultimoFoco&&ultimoFoco.focus) ultimoFoco.focus(); }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-jw-open]')){ e.preventDefault(); abrir(); }
    else if(e.target.closest('[data-jw-close]')) fechar(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!raiz.hidden) fechar(); });

  raiz.addEventListener('click',function(e){
    var b=e.target.closest('[data-jw-tab]'); if(!b) return;
    var alvo=b.getAttribute('data-jw-tab');
    raiz.querySelectorAll('[data-jw-tab]').forEach(function(x){x.classList.toggle('is-on',x===b);});
    raiz.querySelectorAll('[data-jw-pane]').forEach(function(p){
      p.classList.toggle('is-on',p.getAttribute('data-jw-pane')===alvo);}); });

  /* ---------- os tamanhos desta peça, com a amplitude lida do nome ---------- */
  function amplitude(s){
    // "Regular · 55–58 cm", "Eén maat · 55-60 cm", "Large · 57–61 cm"
    var m=(s||'').replace(',','.').match(/(\d{2}(?:\.\d)?)\s*[–—-]\s*(\d{2}(?:\.\d)?)/);
    return m?{a:parseFloat(m[1]),b:parseFloat(m[2])}:null;
  }
  function tamanhos(){
    var out=[];
    document.querySelectorAll('variant-picker,.variant-picker,fieldset,.product-form__input,.variant-wrapper')
      .forEach(function(bl){
        var rot=(bl.textContent||'').slice(0,160).toLowerCase();
        if(!/size|maat|grö|größ|tama/.test(rot)) return;
        bl.querySelectorAll('input[type=radio],option').forEach(function(i){
          var v=i.value||i.getAttribute('value'); if(!v) return;
          var ind=i.disabled||i.classList.contains('disabled')||
                  (i.closest('label')&&i.closest('label').classList.contains('disabled'));
          out.push({v:v,r:amplitude(v),ind:!!ind,el:i}); }); });
    // sem duplicados
    var vis={},u=[]; out.forEach(function(x){ if(!vis[x.v]){vis[x.v]=1;u.push(x);} });
    return u;
  }

  var inp=raiz.querySelector('#jw-hd'), res=raiz.querySelector('[data-jw-res]');
  function pinta(v){
    raiz.querySelectorAll('.jw__regua span').forEach(function(s){
      s.classList.toggle('is-sel', Math.round(v)===parseInt(s.getAttribute('data-cm'),10)); });
    raiz.querySelectorAll('[data-jw-table="hat"] tbody tr').forEach(function(tr){
      var a=parseFloat(tr.getAttribute('data-min')),b=parseFloat(tr.getAttribute('data-max'));
      tr.classList.toggle('is-sel', v>=a-0.01 && v<=b+0.99); });
  }
  if(inp) inp.addEventListener('input',function(){
    var v=parseFloat((inp.value||'').replace(',','.'));
    if(!v||isNaN(v)){ res.hidden=true;
      raiz.querySelectorAll('.is-sel').forEach(function(x){x.classList.remove('is-sel');}); return; }
    res.hidden=false; pinta(v);
    var L=tamanhos().filter(function(x){return x.r;});
    if(!L.length){ res.innerHTML='<b>'+txt('resultado','Your size')+'</b><small>'+
      txt('semtam','This cap comes in one size.')+'</small>'; return; }
    var serve=L.filter(function(x){ return v>=x.r.a-0.01 && v<=x.r.b+0.01; });
    if(!serve.length){
      var min=Math.min.apply(null,L.map(function(x){return x.r.a;}));
      var max=Math.max.apply(null,L.map(function(x){return x.r.b;}));
      if(v>max){ res.innerHTML='<b>—</b><small>'+txt('fora','Outside the sizes we carry')+
        ' ('+min+'–'+max+' cm)</small>'; return; }
      // abaixo do minimo: o mais pequeno que existe
      serve=[L.reduce(function(p,c){return c.r.a<p.r.a?c:p;})];
    }
    // se mais do que um servir, fica o maior (um bone nao estica)
    var alvo=serve.reduce(function(p,c){ return c.r.b>p.r.b?c:p; });
    var h='<b>'+txt('resultado','Your size')+': '+alvo.v+'</b>';
    if(serve.length>1) h+='<small>'+txt('entre','Between two sizes — take the larger, a cap barely stretches')+'</small>';
    if(alvo.ind) h+='<small>'+txt('indisp','not available on this cap')+'</small>';
    else h+='<button type="button" class="jw__pick" data-jw-pick="'+alvo.v.replace(/"/g,'&quot;')+'">'+
            txt('escolher','Select this size')+'</button>';
    res.innerHTML=h;
  });

  raiz.addEventListener('click',function(e){
    var b=e.target.closest('[data-jw-pick]'); if(!b) return;
    var alvo=b.getAttribute('data-jw-pick'), achou=false;
    tamanhos().forEach(function(x){
      if(achou||x.v!==alvo||x.ind) return;
      achou=true;
      if(x.el.tagName==='OPTION'){ x.el.selected=true;
        x.el.parentNode.dispatchEvent(new Event('change',{bubbles:true})); }
      else { x.el.checked=true; x.el.dispatchEvent(new Event('change',{bubbles:true}));
        var lb=x.el.closest('label')||document.querySelector('label[for="'+x.el.id+'"]');
        if(lb) lb.click(); } });
    if(achou) fechar();
  });
})();
